import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { RewardService } from 'src/app/core/api/reward/reward.service';
import { RewardResponseDTO } from 'src/app/shared/models/dtos/responses/reward-response-dto/reward-response-dto';

@Component({
  templateUrl: './reward.page.html',
})
/**
 * Reward page
 */
export class RewardPage implements OnInit {
  reward?: RewardResponseDTO;

  /**
   * @constructor
   */
  constructor(
    private rewardService: RewardService,
    private route: ActivatedRoute
  ) {}

  /**
   * ngOnInit
   */
  ngOnInit(): void {
    const id = this.route.snapshot.params['id'];
    this.getReward(id);
  }

  /**
   *  Get a reward by passing the id
   * @param {number} id
   */
  async getReward(id: number) {
    const reward = await firstValueFrom(this.rewardService.getReward(id));
    this.reward = reward;
  }
}
